mutation CREATE_REVIEW ($reservationId: UUID!, $rating: Int!, $feedback: String) {
  createReview(reservationId: $reservationId, rating: $rating, feedback: $feedback) {
    success
    error
    review {
      id
      rating
      feedback
      rewardCredited
    }
  }
}